import { fg } from '@atlassian/jira-feature-gating';

const RelayProvider = {
	get(): boolean {
		return fg('vsa-adoption-stage-1');
	},
};

export default RelayProvider;
